export default "__VITE_ASSET__BQwWzoCX__"